<template>
  <div class="text-center">
    <v-progress-circular
      :indeterminate="true"
      class="mt-10"
      color="primary"
      size="100"
    ></v-progress-circular>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {};
  },
  mounted() {
    this.getCertificate();
  },
  methods: {
    getCertificate() {
      const apiUrl = this.$store.state.serverUrl;
      const apiToken = this.$store.state.apiToken;
      const apiKey = this.$store.state.serverApiKey;
      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${apiToken}`,
        "x-api-key": apiKey,
      };
      axios
        .get(
          `${apiUrl}api/generali/viewcertificate?policyno=${this.$route.query.policyno}`
        )
        .then(async (response) => {
          await this.$liff.openWindow({
            url: response.data.path.path,
            external: true,
          });

          setTimeout(() => {
            this.$liff.closeWindow();
          }, 500);
        })
        .catch((err) => {
          /* eslint-disable no-console */
          console.error(err);
          /* eslint-enable no-console */
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
